import React from 'react';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

const ModalUsados = ({ isOpen, onClose, selectedItem }) => {
    if (!isOpen || !selectedItem) return null;

    return (
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                background: 'rgba(0, 0, 0, 0.5)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 1000,
                padding: '10px', 
                maxWidth: '100vw',
            }}
        >
            <div className='md:w-2/3'
                style={{
                    position: 'relative',
                    height:'auto',
                    background: '#fff',
                    padding: '20px',
                    borderRadius: '10px',
                    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)',
                    textAlign: 'center',
                    display: 'flex',
                    flexWrap: 'wrap',
                    maxWidth: '100%',
                }}
            >
                <button
                    onClick={onClose}
                    style={{
                        position: 'absolute',
                        top: '10px',
                        right: '15px',
                        fontSize: '24px',
                        cursor: 'pointer',
                        border: 'none',
                        background: 'transparent',
                        color: '#333',
                    }}
                >
                    ✖
                </button>

                <h2
                    style={{
                        fontSize: '24px',
                        fontWeight: 'bold',
                        marginBottom: '10px',
                        color: 'black',
                        flex:"100%",
                    }}
                >
                    {selectedItem.marca} {selectedItem.modelo}
                </h2>

               <div className='flex flex-col w-full lg:flex-row lg:justify-start lg:items-start'>
               <Swiper
               className='w-full lg:w-1/2'
                    slidesPerView={1}
                    spaceBetween={10}
                    pagination={{ clickable: true }}
                    navigation
                    loop={true}
                    modules={[Pagination, Navigation]}
                    style={{
                        
                        height: '',
                        marginLeft:'0',
                        marginRight:'0',
                      
                    }}
                    breakpoints={{
                        768:{
                           
                        },
                    }}
                >
                    {selectedItem.fotos.map((foto, index) => (
                        <SwiperSlide key={index}>
                            <Zoom overlayBgColorEnd='rgba(0, 0, 0, 0)'>
                                <img
                                    src={foto}
                                    alt={`${selectedItem.marca} ${selectedItem.modelo}`}
                                    style={{
                                        width: '100%',
                                        height: 'auto',
                                       
                                      
                                    }}
                                />
                            </Zoom>
                        </SwiperSlide>
                    ))}
                </Swiper>
                <div className='flex flex-col items-start justify-center flex-1 h-full px-4 lg:w-1/2'>
               <div className=' chips text-left  flex-1 grid gap-2 grid-cols-3 w-full h-full max-h-[320px] '>
               <div className='text-black'>
                    <strong>Año:</strong> <p>{selectedItem.año}</p>
                </div>
                <div className='text-black'>
                    <strong>Cilindrado:</strong> <p>{selectedItem.cilindradaMotor}</p>
                </div>
               <div className='text-black'>
                    <strong>Versión:</strong> <p>{selectedItem.variante}</p> 
                </div>
                {selectedItem.tipoVehiculo !== '' && (
                    <div className='text-black '>
                        <strong>tipo de vehículo:</strong> <p>{selectedItem.tipoVehiculo}</p>
                    </div>
                )}
                <div className='text-black '>
                    <strong>tipo de combustible:</strong><p> {selectedItem.tipoCombustible}</p>
                </div>
                
               
                <div className='text-black'>
                    <strong>Estado General:</strong> <p>{selectedItem.estadoGeneral}</p> 
                </div>
                <div className='text-black'>
                    <strong>Transmisión:</strong><p> {selectedItem.transmision}</p>
                </div>
                <div className='text-black'>
                    <strong>Kilometraje:</strong>{' '}
                   <p> {selectedItem.kilometraje
                        ? selectedItem.kilometraje.toLocaleString('es-ES')
                        : 'No disponible'}</p>
                </div>
               
               </div>
               <div>
               <div className='w-full mt-auto text-l'
                    style={{
                        fontSize: '18px',
                        fontWeight: 'bold',
                        color: '#fcb414',
                    }}
                >
                    <p>Precio final: $
                    {selectedItem.precioVenta
                        ? selectedItem.precioVenta.toLocaleString()
                        : 'Precio no disponible'}</p>
                </div>
               </div>
               <a
    href={`https://wa.me/5492634588256?text=Hola!%20tengo%20una%20consulta%20sobre:%20${encodeURIComponent(selectedItem.marca)}%20${encodeURIComponent(selectedItem.modelo)}`}
    target='_blank'
    rel='noopener noreferrer'
>
    <button
        onClick={onClose}
        style={{
            width: '100%',
            padding: '10px',
            marginTop: '15px',
            background: '#fcb414',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            fontSize: '18px',
            fontWeight: 'bold',
        }}
    >
        Contactar
    </button>
</a>
               
                </div>
               </div>
               

                
            </div>
        </div>
    );
};

export default ModalUsados;
